import { Sparkles } from "lucide-react";

export default function AnimationBlock({
  index,
  currentAnimation,
  clipAnimationTiming,
  setClipAnimationTiming,
  animationDuration,
  onSelectAnimation
}) {
  return (
  <div
    onClick={() => onSelectAnimation(index)}
    title={currentAnimation || "No Animation"}
    className={`
      inline-flex items-center gap-1
      px-2 py-[2px]
      rounded text-[10px]
      cursor-pointer select-none
      border transition
      ${
        currentAnimation
          ? `
            bg-purple-100 text-purple-700 border-purple-300
            dark:bg-purple-900 dark:text-purple-200 dark:border-purple-500
          `
          : `
            bg-gray-100 text-gray-600 border-gray-300
            dark:bg-gray-900 dark:text-gray-400 dark:border-gray-700
          `
      }
      hover:bg-purple-200 dark:hover:bg-purple-800
    `}
    style={{ width: "fit-content" }}
  >
    <Sparkles size={12} />
    <span className="whitespace-nowrap">
      {currentAnimation || "None"}
    </span>

    <span className="text-[9px] opacity-70 ml-1">
      {clipAnimationTiming === "start" && "⏮"}
      {clipAnimationTiming === "end" && "⏭"}
      {clipAnimationTiming === "both" && "⏮⏭"}
    </span>

    <span className="text-[9px] opacity-60 ml-1">
      {animationDuration?.[index]}s
    </span>
  </div>
);

}
